import { render, staticRenderFns } from "./LiquidationTable.vue?vue&type=template&id=04339110&scoped=true&"
import script from "./LiquidationTable.vue?vue&type=script&lang=js&"
export * from "./LiquidationTable.vue?vue&type=script&lang=js&"
import style0 from "./LiquidationTable.vue?vue&type=style&index=0&id=04339110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04339110",
  null
  
)

export default component.exports